import React from "react";
import SectionTitle from "../../../components/SectionTitle";
import { useTournament, useTournamentUpdate } from "../TournamentContext";
import { doc, updateDoc } from "firebase/firestore";
import { firestore } from "../../../firebase/config";
import AddMockPlayers from "./components/AddMockPlayers";
import PlayerCard from "./components/PlayerCard";

const Players = () => {
  const { tournament, tournamentId, isUserOrganizer, profiles } =
    useTournament();
  const { updateTournament } = useTournamentUpdate();

  const { isTeamsPublic, playerIds } = tournament;

  const togglePublicity = async () => {
    const tournamentRef = doc(firestore, "tournaments", tournamentId);

    updateTournament("isTeamsPublic", !isTeamsPublic);
    try {
      await updateDoc(tournamentRef, { isTeamsPublic: !isTeamsPublic });
    } catch (error) {
      alert("Something went wrong updating the visibility!", error.message);
    }
  };

  return (
    <section className="w-full flex flex-col items-center mb-6">
      <SectionTitle
        title={"Players"}
        isPublic={isTeamsPublic}
        handlePublicity={togglePublicity}
        tournamentId={tournamentId}
      />

      <AddMockPlayers tournamentId={tournamentId} playerIds={playerIds} />

      {profiles && (
        <div className="flex flex-wrap justify-center mt-4">
          {playerIds?.map((playerId) => {
            const profile = profiles[playerId];

            return (
              <PlayerCard
                key={playerId}
                isUserOrganizer={isUserOrganizer}
                playerId={playerId}
                profile={profile}
              />
            );
          })}
        </div>
      )}
    </section>
  );
};

export default Players;
